import React from 'react'
import { useSelector } from 'react-redux'
import { makeStyles, Icon } from '@material-ui/core'
import { warnings } from '../../utils/colors'
import { FONT_WEIGHTS } from '../../utils'

/**
 * Shown while booking a visit at a facility other than the client's default.
 * The facility comes from the header selector, which is also what the wizards price and charge against.
 */
const DifferentFacilityBookingWarning = ({ facility, defaultFacilityId, style = {} }) => {
	const classes = useStyles()
	const facilities = useSelector((state) => state.specific.facilities.facilities)

	if (!facility?._id || !defaultFacilityId) return null
	if (String(facility._id) === String(defaultFacilityId)) return null

	const homeFacility = (facilities || []).find((entry) => String(entry._id) === String(defaultFacilityId))
	const visitName = facility.name || 'the selected location'
	const homeName = homeFacility?.name || 'their default facility'

	return (
		<div className={classes.root} style={style}>
			<Icon className={`fa fa-exclamation-triangle ${classes.icon}`} />
			<div>
				<div className={classes.title}>This visit is not at the client's default facility</div>
				<div className={classes.body}>
					This appointment is being booked at {visitName}. This client's default facility is {homeName}.
					Charges for this visit use {visitName}.
				</div>
			</div>
		</div>
	)
}

const useStyles = makeStyles(() => ({
	root: {
		backgroundColor: warnings[10],
		border: `2px solid ${warnings[500]}`,
		borderRadius: '.5rem',
		padding: '1rem 1.25rem',
		display: 'flex',
		gap: '1rem',
		alignItems: 'flex-start',
		width: '100%'
	},
	icon: {
		color: warnings[500],
		fontSize: '1.5rem',
		overflow: 'unset'
	},
	title: {
		fontFamily: 'Nunito',
		fontSize: '1.125rem',
		fontWeight: FONT_WEIGHTS.Bold,
		color: warnings[700],
		marginBottom: '.25rem'
	},
	body: {
		fontFamily: 'Nunito',
		fontSize: '0.9375rem',
		fontWeight: FONT_WEIGHTS.Regular,
		color: 'black'
	}
}))

export default DifferentFacilityBookingWarning
